import React, { Component } from "react";
import { connect } from "react-redux";
import * as getContent from "~/store/getContent/getContentAction";

class GetContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = async () => {
    // const content = await getHttpRequest(
    //   `${currentEnv.STATIC_CONTENT_API_URL}/static/upload/hospitals/${AppId}/content.json`
    // );
    // const objectContent = jsonFormat(content.data);
    // this.props.getContent(objectContent);
    // console.log(AppId)
  };

  render() {
    // console.log(this.props.content);
    return <React.Fragment />;
  }
}

const mapStateToProps = state => {
  // console.log(state.getContent)
  const { getContent } = state;
  return {
    content: getContent
  };
};

const mapDispatchToProps = dispatch => ({
  getContent: objectContent => {
    dispatch(getContent.getContent(objectContent));
  }
  // selectFeatureBookingById: id => {
  //   dispatch(featuresActions.selectFeatureBookingById(id));
  // }
});

export default connect(mapStateToProps, mapDispatchToProps)(GetContent);
